// engine
import { ArContainer, ArSprite, ORIENTATION } from '@aceroll/core';

export class GameLogo extends ArContainer {
	#logo = null;

	constructor() {
		super('logo');
		this.#logo = ArSprite.from('preloader-game_logo');
		this.#logo.anchor.set(0.5);
		this.#logo.position.set(0, 0);

		this.addChild(this.#logo);
	}

	applyInGameSettings() {
		this.baseSize = {
			[ORIENTATION.LANDSCAPE]: {
				width: 2048,
				height: 945
			},
			[ORIENTATION.PORTRAIT]: {
				width: 945,
				height: 2048
			}
		};

		this.baseAnchor = {
			[ORIENTATION.LANDSCAPE]: {
				x: 0,
				y: 0
			},
			[ORIENTATION.PORTRAIT]: {
				x: 0,
				y: 0
			}
		};

		this.scaleMode = 'min';

		this.#logo.anchor.set(0);
		this.#logo.position.set(20, 20);
	}
}
